<!-- Cards with media area -->
<mat-card class="notification-card" *ngIf="notification" [ngClass]="{'read': notification.read}">
  <mat-card-title-group>
    <mat-card-title (click)="itemClick(notification)">
      {{notification.title}}
    </mat-card-title>
    <mat-card-subtitle>{{notification.created_at|readableDate:true}}</mat-card-subtitle>
    <img class="card-img-sm-cover" (click)="itemClick(notification)" *ngIf="notification.image!=null" mat-card-sm-image src="{{notification.image}}"
         alt="{{notification.title}}">
  </mat-card-title-group>
  <mat-card-content (click)="itemClick(notification)">
    {{notification.description}}
  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-button *ngIf="!notification.read" (click)="onActionRead(notification.id,true)">MARK READ</button>
    <button mat-button *ngIf="notification.read" (click)="onActionRead(notification.id,false)">MARK UNREAD</button>
  </mat-card-actions>
</mat-card>
